import type { BookingPostalAddressInput, BookingPostalAddress } from 'owa-graph-schema';

const mapToBookingPostalAddressInput = (
    address: BookingPostalAddress
): BookingPostalAddressInput => {
    const { name, street, city, state, countryOrRegion, postalCode, postOfficeBox, type } =
        address as BookingPostalAddress;

    const addressInput: BookingPostalAddressInput = {
        name,
        street,
        city,
        state,
        countryOrRegion,
        postalCode,
        postOfficeBox,
        type,
    };

    return addressInput;
};

export default mapToBookingPostalAddressInput;
